import YAside from './src/main'

YAside.install = function(Vue) {
  Vue.component(YAside.name, YAside)
}

export default YAside
